<template>
  <!-- 翠麟点映，活动详情 -->
  <div>
    <div class="container">
      <Bread :list="breadList" class="ma-t-30" />
      <div class="flex ma-t-30">
        <div class="width60">
          <img
            :src="detail.Image"
            alt=""
            srcset=""
            class="img_cover width100"
            height="350"
          />
        </div>
        <div class="flex1 pa-20">
          <div class="flex f-between">
            <div class="fon-20 t-omit-1" :title="detail.ActivityName">
              {{ detail.ActivityName }}
            </div>
            <div class="c-red font-bold fon-22">￥{{ detail.Price }}</div>
          </div>
          <div class="ma-t-10 c-666">{{ detail.Summary }}</div>
          <div class="ma-t-10 c-666">
            <i class="el-icon-time"></i>
            {{ detail.StartTime }} - {{ detail.EndTime }}
          </div>
          <div class="c-666 ma-t-10">
            <i class="el-icon-location-outline"></i>
            {{ detail.Address }}
          </div>
          <div class="flex f-between c-666 ma-t-10 f-center">
            <div>
              <i class="el-icon-phone-outline"></i>
              {{ detail.Phone }} {{ detail.Contact }}
            </div>
            <div class="btn-detail" v-if="detail.IsBuy">已购买</div>
            <div class="btn-detail c-p" v-else @click="pickBuydialogVisible=true">在线购买</div>
          </div>
        </div>
      </div>

      <div class="menu-item fon-24 ma-t-60">
        <div class="font-bold">展映作品</div>
        <div class="font-bold">Exhibition works</div>
        <img
          src="../img/index/index21.png"
          class="item-right"
          alt=""
          srcset=""
        />
        <img
          src="../img/index/index22.png"
          class="item-left"
          alt=""
          srcset=""
        />
      </div>
      <div class="flex f-wrap ma-t-30">
        <div
          class="box-item ma-b-0 t-center c-p"
          v-for="(item2, index2) in detail.MovieList"
          :key="index2"
        >
          <img
            :src="item2.Image"
            width="100%"
            height="80%"
            class="img_cover b-r-15"
            alt=""
            srcset=""
          />
          <div class="ma-t-20 t-omit-1">{{ item2.Name }}</div>
        </div>
      </div>
      <Empty :isShow="detail.MovieList.length==0"></Empty>

      <div class="menu-item fon-24 ma-t-60">
        <div class="font-bold">详细介绍</div>
        <div class="font-bold">Detailed introduction</div>
        <img
          src="../img/index/index21.png"
          class="item-right"
          alt=""
          srcset=""
        />
        <img
          src="../img/index/index22.png"
          class="item-left"
          alt=""
          srcset=""
        />
      </div>
      <div class="li-html pa-tb-20" v-html="detail.Content"></div>
      <Empty :isShow="!detail.Content"></Empty>
    </div>

    <!-- 确认购买数量弹框 -->
    <el-dialog
      :visible.sync="pickBuydialogVisible"
      width="30%"
      @before-close="pickBuydialogVisible = false"
    >
      <div class="pa-tb-20">
        <div class="flex ">
          <div class="width20">支付金额:</div>
          <div>{{ buyCount * detail.Price }}</div>
        </div>
        <div class="flex ma-t-20">
          <div class="width20">支付方式:</div>
          <div>微信支付</div>
        </div>
        <div class="flex ma-t-20">
          <div class="width20">最大数量:</div>
          <div>{{ detail.Limit }}</div>
        </div>
        <div class="flex  ma-t-20">
          <div class="width20">购买数量:</div>
          <div>
            <el-input-number v-model="buyCount" controls-position="right" :min="1" :max="detail.Limit"></el-input-number>
          </div>
        </div>
        <div class="flex f-jcenter ma-t-20">
           <div class="btn-detail c-p" @click="buy">确认购买</div>
        </div>
      </div>
    </el-dialog>

    <!-- 支付弹框二维码 -->
    <el-dialog
      :visible.sync="paydialogVisible"
      width="30%"
      @before-close="paydialogVisible = false"
    >
      <div>
        <payment :payKey="payKey" @paySuccess="paySuccess" v-if="paydialogVisible"></payment>
      </div>
    </el-dialog>
  </div>
</template>
  
  <script>
import { getShowingDetail, getShowingBuy } from "../api.js";
import payment from "../components/payment.vue";
export default {
  components: {
    payment,
  },
  data() {
    return {
      breadList: [
        {
          name: "翠麟点映",
          path: "/showing/site/index",
        },
        {
          name: "详情",
          path: "/showing/site/detail",
        },
      ],
      detail: {},
      id: 0,
      siteId: 0,
      paydialogVisible: false,
      pickBuydialogVisible:false,
      payKey: "",
      buyCount:1
    };
  },
  activated() {
    this.id = this.$route.query.id;
    this.siteId = this.$route.query.siteId;
    this.loadData();
  },
  methods: {
    buyCountChange(){
      if(this.buyCount> this.detail.Limit){
        this.buyCount=this.detail.Limit
      }
    },
    loadData() {
      getShowingDetail({ activityId: this.id, siteId: this.siteId }).then(
        (res) => {
          this.detail = res.data.Data;
        }
      );
    },
    //支付成功
    paySuccess() {
      this.paydialogVisible = false;
      this.pickBuydialogVisible = false;
      this.loadData();
    },
    //下单购买
    buy() {
      getShowingBuy({ ActivityId: this.id, Count: this.buyCount }).then((res) => {
        this.payKey = res.data.Data.Key;
        this.paydialogVisible = true;
      });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.menu-item {
  position: relative;
  .item-right {
    position: absolute;
    right: 0;
    top: 0;
  }
  .item-left {
    position: absolute;
    left: 0;
    top: 0;
  }
}

.box-item {
  width: 18%;
  height: 320px;
}
.box-item:not(:nth-child(5n)) {
  margin-right: calc(10% / 5);
}

.btn-detail {
  width: 119px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  background: #fb004d;
  border-radius: 20px;
  color: #fff;
}
</style>